import { MessageService } from './MessageService';
import { createRequestResponseMessaging } from '@passionware/messaging-react';

export function createMessageService(): MessageService {
  return {
    createCustomField: createRequestResponseMessaging()
  };
}
